import { Grid, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import Banner from 'common/components/Banner/Banner';
import TabBar from 'common/components/TabBar/TabBar';
import { REPORTING_SECTION_TITLE } from 'common/constants/ReportingLibraryConstants';
import { RootState } from 'common/store/AppStore';
import { toSentenceCase } from 'common/utils/utilFunctions';

import ReportingLibraryCardView from './ReportingCardView';
import ReportingLibraryBanner from './ReportingLibraryBanner';
import { reportingTabs, updateTabName } from './ReportingLibraryUtils';

import styles from './ReportingLibrary.module.scss';

const reportingTabPanels = [
	{
		id: 1,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 2,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 3,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 4,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 5,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 6,
		children: <ReportingLibraryCardView />,
	},
	{
		id: 7,
		children: <ReportingLibraryCardView />,
	},
];

const ReportingLibrary = () => {
	const dispatch = useDispatch();
	const reportingTabIndex = useSelector(
		(state: RootState) =>
			state?.common?.selectedReportingLibraryTab.reportingLibraryTabIndex,
	);
	const handleReportingTabChange = (index: number) => {
		updateTabName(index, dispatch);
	};

	return (
		<Grid container data-testid="reporting-library">
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<Banner>
					<ReportingLibraryBanner />
				</Banner>
			</Grid>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				className={styles['reporting-section-grid']}
			>
				<Typography className={styles['reporting-section-title']}>
					{toSentenceCase(REPORTING_SECTION_TITLE)}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<TabBar
					testId="reporting-tab-testid"
					activeTab={reportingTabIndex}
					details={reportingTabs}
					showCount={false}
					components={reportingTabPanels}
					showButton={false}
					onTabChange={handleReportingTabChange}
				/>
			</Grid>
		</Grid>
	);
};

export default ReportingLibrary;
